import { ajax } from '../../../services/helper'
class ApiService {

    getsTReportsData = (from,to,city_id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/storeTickets/summary?from="+from+"&to="+to
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

    getHRTicketDetailsById = (id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/hrTickets/"+id+"/editInfo"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

    



    
   

}
export default new ApiService()


// WEBPACK FOOTER //
// ./src/modules/ST Reports/services/apiservices.js